module.exports = __webpack_public_path__ + "img/Twist-01.12cbf410.jpg";